import React, { useEffect, useState } from 'react'
import Housestyle from '../assets/house-style.png'
import Pricerange from '../assets/price-range.png'
import Minibedicon from '../assets/mini-bed-icon.png'
import Bathicon from '../assets/bath-icon.png'
import Houseareaicon from '../assets/house-area-icon.png'
import { useProperty } from '../context/PropertyContext.js'
import { useParams, useSearchParams } from 'react-router-dom'
import StarRating from './StarRating.js'
import { useAuth } from '../context/AuthContext.js'
import { useComment } from '../context/commentContext.js';
import Reply from '../assets/reply.png'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditComment from './EditComment.js'
import ReplyIcon from '../assets/send.png'
import { useReply } from '../context/ReplyContext.js'
import UserIcon from '../assets/user-icon.png'
import EditReply from './EditReply.js'
import { useNotification } from '../context/NotificationContext.js'


const serverUrlImage = 'https://osdevhub.com/projects/homify/uploads';

function formatWithComma(price) {
    return parseInt(price).toLocaleString('en-US');
}

function PropertyReview() {
    const [editCommentModal, setEditCommentModal] = useState(false);
    const [currentComment, setCurrentComment] = useState(null)
    const [userRating, setUserRating] = useState('');
    const [userComment, setUserComment] = useState('')

    const {id} = useParams()
    const [searchParams] = useSearchParams();
    const user_id = searchParams.get('user_id')

    const {user} = useAuth();

    const {
        fetchOneProperty, 
        singleProperty, 
        propertyIsLoading, 
    } = useProperty();

    const {
        postComment,
        comments,
        commentIsLoading,
        getCommentsForProperty
    } = useComment();

    const {postNotification} = useNotification();

    console.log(userRating);
    

    useEffect(() => {
        fetchOneProperty(id, user_id)
    }, [])

    function handleSetRating(rating) {
        setUserRating(rating)
    }

    function handleChange(e) {
        setUserComment(e.target.value)
       console.log(userComment);
    }

    async function handleSubmit(e) {
        e.preventDefault();

        if(userRating === '' || userComment === '') {
            return  toast.error('Please add a rating and a comment', {position: "top-right", autoClose: 2000})
        }

        const commentData = {
            rating: parseInt(userRating),
            comment: userComment,
            property_id: parseInt(id),
            user_id: parseInt(user.id),
            status: 'approved'
        }

        await postComment(commentData);
        await getCommentsForProperty(id);

        setUserRating('')
        setUserComment('');

          toast.success('Comment added successfully', {position: "top-right", autoClose: 2000})

          const notifyData ={
            message: parseInt(user.id) === parseInt(user_id) ? `You commented on your property '${singleProperty.name_of_property}'` :  `${user.name} commented on your property '${singleProperty.name_of_property}' `,
            type: 'personal',
            user_id: user_id,
            sender_id: user.id,
            url: `/dashboard/homeproperties/${id}?user_id=${user_id}`
          }


          await postNotification(notifyData)
    }

    useEffect(() => {
        getCommentsForProperty(id);
    }, []);

    const openEditModal = (comment) => {
        setEditCommentModal(true);
        setCurrentComment(comment);
      }

    const closeEditModal = () => {
        setEditCommentModal(false);
      }

    if(propertyIsLoading) return <section id="seller-section" className="property-container margin-top2">  <h2 className='margin-top'>Loading...</h2></section>
  return (
    <div className='property-review-container'>
        <ToastContainer />
        <EditComment  isOpen={editCommentModal} onClose={closeEditModal} currentComment={currentComment}  />
        <div className="margin-top2 recommendation-card2">
            <img src={`${serverUrlImage}/${singleProperty?.image}`} alt={singleProperty?.name} />
            <div className='review-container'>
                <div  className="recommendation-carddetails">
                    <h4>N{formatWithComma(singleProperty?.price)}</h4>
                    <p>{singleProperty?.address}</p>
                    <p>{singleProperty?.transaction}</p>
                    <p><strong>Availability:</strong> Still available</p>
                </div>
                <div className="inner-carddetails2">
                    <div className="innerdetails-content">
                        <div className="innerdetails-image">
                            <img src={Minibedicon} alt="" />
                            <p>{singleProperty?.no_bedroom}</p>
                        </div>
                        <p>Bedroom</p>
                    </div>
                    <div className="innerdetails-content">
                        <div className="innerdetails-image">
                            <img src={Bathicon} alt="" />
                            <p>{singleProperty?.no_bathroom}</p>
                        </div>
                        <p>Bathroom</p>
                    </div>
                    <div className="innerdetails-content">
                        <div className="innerdetails-image">
                            <img src={Houseareaicon} alt="" />
                            <p>{formatWithComma(singleProperty?.house_area)}m</p>
                        </div>
                        <p>House Area</p>
                    </div>
                </div>
                <div className="inner-carddetails">
                    <div className="innerdetails-content2">
                        <div className="innerdetails-image">
                            <p>Posted By: {singleProperty?.user_name}</p>
                        </div>
                        <div  className="recommendation-carddetails">
                                <p>Phone no: {singleProperty?.user_phone}</p>
                            </div>
                        <div  className="recommendation-carddetails">
                                <p>Email: {singleProperty?.user_email}</p>
                            </div>
                    </div>
                </div>
                      <div  className="recommendation-carddetails">
                         <p><strong>Description:</strong> {singleProperty?.description}</p>
                            </div>

                <div className="innerdetails-image">
                    <p>Status: Approved</p>
                </div>
           
                    
            </div>
        </div>
        <div className='comment-container'>
            <h2 className='comment-header-text'>Comments</h2>
            <div className="reviews-list">
                {commentIsLoading && <p style={{color:'#000'}}>Loading...</p>}
                {comments ? comments.map((comment, index) => {return <ReviewCard 
                key={index} 
                comment={comment}
                user={user}
                user_id={user_id}
                openEditModal={openEditModal}
                
                />})
             : null}
            </div>
        </div>
        <div className="property-review-section">
            <form className="add-review-form" onSubmit={handleSubmit}>
                <div className="rating-input">
                    <label>Rating:</label>
                    <StarRating  onSetRating={handleSetRating} />
                </div>
                <textarea value={userComment} onChange={handleChange} placeholder="Leave your comment here..." />

                <div className='review-button-container'>
                    <button type="submit">
                        {
                            commentIsLoading ? 'Posting...' : 'Post Review'
                        }
                    </button>
                </div>
               
            </form>
        </div>
    </div>
          
  )
}


function ReviewCard({comment, openEditModal}){
    const {deleteComment, getCommentsForProperty, propertyIsLoading} = useComment()
    const [currentReply, setCurrentReply] = useState(null)
    const [chosenReply, setChosenReply] = useState(null)
    const [replyText, setReplyText] = useState("");
    const [editReplyModal, setEditReplyModal] = useState(false);
    const [showReply, setShowReply] = useState(false)

    const {id : propertyId} = useParams();
    const [searchParams] = useSearchParams();
    const user_id = searchParams.get('user_id')

    const {addReply, 
        getRepliesForProperty, 
        replies: allReplies,
        deleteReply,
    } = useReply()

    const {user} = useAuth();

    const {postNotification} = useNotification();
    

    function handleSetRating() {
        return null
    }

    async function handleDelete(id) {
        console.log('the id');
        
        await deleteComment(id);
        await getCommentsForProperty(propertyId);


        toast.success('Comment deleted successfully', {
            position: "top-right",
            autoClose: 2000
        });

    }

    async function handleDeleteReply(id) {
        
        await deleteReply(id);
        getRepliesForProperty(propertyId)


        toast.success('Reply deleted successfully', {
            position: "top-right",
            autoClose: 2000
        });

    }

    function formatDate(isoString) {
        const date = new Date(isoString);
    
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        };
    
        return date.toLocaleString('en-US', options);
    }

    function handleOpenReply(id) {
        setCurrentReply(currentReply === id ? null : id);
        
    }

    async function handleReplySubmit(event) {
        event.preventDefault();

        let data = {
            reply: replyText, 
            comment_id: comment.id, 
            user_id: user.id, 
            property_id: propertyId
        }
  

        if (!replyText.trim()) return;


    

        await addReply(data);
        await getRepliesForProperty(propertyId)

        setReplyText("");
        setCurrentReply(null);
        toast.success('Reply added successfully!', {
            position: "top-right",
            autoClose: 2000
        });

        const notifyData ={
            message: parseInt(user.id) === parseInt(comment.user_id) ? `You commented on your comment '${comment.comment}'` :  `${user.name} commented on your comment '${comment.comment}' `,
            type: 'personal',
            user_id: comment.user_id,
            sender_id: user.id,
            url: `/dashboard/homeproperties/${propertyId}?user_id=${user_id}`
          }

        await postNotification(notifyData)


    }

    function handleReplyTextChange(e) {
        let value = e.target.value;

        setReplyText(value);
        
    }

    const openReplyEditModal = (reply) => {
        setEditReplyModal(true);
        setChosenReply(reply);
      }

      const closeEditModal = () => {
        setEditReplyModal(false);
      }

    useEffect(() => {
        getRepliesForProperty(propertyId)
        
    }, [])

    
    return(
        <div className="review-card">
              <EditReply  isOpen={editReplyModal} onClose={closeEditModal} reply={chosenReply}  />
            <div className="review-header">
                <div className='user-icon-container'>
                    <img className='user-icon' src={UserIcon} alt='user-icon' />
                    <span className="review-author">{comment?.user_name}</span>
                </div>
                <span className="review-date">{formatDate(comment?.created_at)}</span>
            </div>
            <p className="review-content">{comment?.comment}</p>
            <p className="review-rating"><StarRating defaultRating={comment?.rating}  onSetRating={handleSetRating} /></p>
            <div className='review-edit-container'>

            {
                user.id === comment.user_id &&  <button onClick={() => openEditModal(comment)} className='review-edit-button'>edit</button>
            }
            {
                user.id === comment.user_id &&  <button onClick={() => handleDelete(comment.id)} className='review-edit-button red-delete'>delete</button>
            }

            <button onClick={() => handleOpenReply(comment.id)} className='review-edit-button blue-reply'>reply</button>
     
          
             </div>
             {
                comment.id ===  currentReply ?(<form onSubmit={handleReplySubmit} className='reply-form'>
                    <input value={replyText} onChange={handleReplyTextChange} className='reply-input' type='text' />
                    <button className='reply-button-out' type='submit'><img src={ReplyIcon} alt='reply-button' className='reply-button' /></button>
                </form>) : null
             }
        
            <div className='reply-container'>
                <h4 onClick={() => setShowReply(!showReply)} className='show-reply'>{showReply ? 'hide replies ' : 'show replies'} <img className='reply-icon' src={Reply} alt='reply icon' /></h4>
            </div>

            {
               showReply && allReplies && allReplies?.map(reply => 
                    reply.comment_id === comment.id ? 
                    <div className='main-reply-container'>
                        <div className="review-header">
                            <div className='user-icon-container'>
                                <img className='user-icon' src={UserIcon} alt='user-icon' />
                                <span className="review-author">{reply?.user_name}</span>
                            </div>
                            <span className="review-date">{formatDate(reply?.created_at)}</span>
                        </div>
                        <p className="review-content">{reply?.reply}</p>
                        <div className='review-edit-container'>
                        {
                            user.id === reply.user_id &&  <button onClick={() => openReplyEditModal(reply)} className='review-edit-button'>edit</button>
                        }
                        {
                            user.id === reply.user_id &&  <button onClick={() => handleDeleteReply(reply.id)} className='review-edit-button red-delete'>delete</button>
                        }
                        </div>

                    </div> : 
                    null
                )
            }
      
        </div>
    )
}



export default PropertyReview